module.exports = __webpack_public_path__ + "97ba5247c934f2fcf1e720f7ef5a1177.png";